'use client'

import { RefreshRouteOnSave } from '@payloadcms/live-preview-react'
import { useRouter } from 'next/navigation.js'

// serverURL must match the admin panel's origin for postMessage events to be
// accepted by Payload's RefreshRouteOnSave. Admin loads from the branch alias
// (e.g. *-git-<branch>-<team>.vercel.app) on previews and from NEXT_PUBLIC_SITE_URL
// in production — so the value we hand to serverURL has to follow.
//
// VERCEL_URL is the per-deployment HASH alias which changes every redeploy and
// is cross-origin from the admin — wrong choice here. VERCEL_BRANCH_URL is
// stable per-branch and matches the admin's origin.
//
// Dev branch exception: the dev branch has the custom domain dev.efficient.app
// attached and admin loads from that domain (not the underlying branch alias).
// Use the canonical domain so postMessage origins match. Mirror of the
// detection in src/lib/auth/env-override.ts and src/live-preview/format.ts.
//
// Vercel exposes NEXT_PUBLIC_VERCEL_BRANCH_URL / NEXT_PUBLIC_VERCEL_ENV to the
// client bundle when "Enable access to System Environment Variables" is on in
// project settings. EA-719.
const serverURL = (() => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
    return process.env.NEXT_PUBLIC_SITE_URL ?? ''
  }
  const branchUrl = process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL
  if (branchUrl) {
    if (branchUrl.includes('efficient-git-dev-efficientapp')) {
      return 'https://dev.efficient.app'
    }
    return `https://${branchUrl}`
  }
  return process.env.NEXT_PUBLIC_SITE_URL ?? ''
})()

export default function RefreshLivePreview() {
  const router = useRouter()

  return <RefreshRouteOnSave refresh={() => router.refresh()} serverURL={serverURL} />
}
